
  module.exports =
  {

    products:
    {

      _init: function ()
      {

        $('#check-all').not('.js-ignore').click(function ()
        {

          $(this).toggleClass('js-checked')

          $('.js-product').prop('checked', $(this).is('.js-checked'))

        }
        ).addClass('.js-ignore')
  
      }

    }

  }